<template>
  <header class="masthead">
    <div class="container d-flex h-100 align-items-center">
      <div class="mx-auto text-center">
        <h1 class="mx-auto my-0 text-uppercase">{{ t('nav.brand') }}</h1>
        <h2 class="text-white-50 mx-auto mt-2 mb-5">{{ t('masthead.subtitle') }}</h2>
      </div>
    </div>
  </header>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>
